(function () {
    'use strict';

    angular.module("imApp").factory("p2UpdateTablesService", ['$ihttp', function ($ihttp) {
        let service = {
            getUpdateTables: function (parms) {
                return $ihttp.post({
                    method: 1401,
                    parameters: parms || {}
                });
            },
            listUpdateTables: function (parms) {
                return $ihttp.post({
                    method: 204,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
